/* DESIGN BF v1+ 2026-10-11 · progressive enhancement only: every section is complete without this file.
   Each feature runs in its own try/catch so one failure never takes the others (or the store) down. */
(function () {
  if (window.BFv1p) return;
  window.BFv1p = 1;
  var W = window, D = document, H = D.documentElement;
  var RM = W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = W.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var EASE = 'cubic-bezier(.23,1,.32,1)';
  var BLOCKED = /^\/(cart|checkout|checkouts|account)(\/|$)/.test(location.pathname);
  var hasIO = 'IntersectionObserver' in W;

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function each(r, s, f) { Array.prototype.forEach.call(r.querySelectorAll(s), f); }
  function safe(f, r) { try { f(r); } catch (e) { if (W.console) console.warn('[BF v1+]', e); } }
  function drawerOpen() {
    var c = D.querySelector('cart-drawer');
    return !!(c && c.classList.contains('active')) || !!D.querySelector('quick-add-modal[open]');
  }
  function klaviyoOpen() {
    /* Klaviyo pop-ups are position:fixed, so offsetParent is always null: check the box instead */
    var ks = D.querySelectorAll('.needsclick[role="dialog"], [class*="kl-private-reset"][role="dialog"], .klaviyo-form[role="dialog"]');
    for (var i = 0; i < ks.length; i++) {
      var r = ks[i].getBoundingClientRect(), cs = getComputedStyle(ks[i]);
      if (r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none' && +cs.opacity > 0) return true;
    }
    return false;
  }
  function modalOpen() { return !!D.querySelector('.bf-modal[open]'); }

  /* Tickers: pause while offscreen (hover/focus pause is CSS) */
  var tkIO = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
  }) : null;
  function tickers(r) { if (tkIO) each(r, '[data-bf-tk]', function (t) { tkIO.observe(t); }); }

  /* Countdown: one fixed end time from the section setting; never resets per visitor */
  var cds = [], timer = 0;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function roll(el, str, instant) {
    var s = el.children, i;
    if (s.length !== str.length) {
      el.innerHTML = '';
      for (i = 0; i < str.length; i++) {
        var a = D.createElement('span'); a.className = 'bf-cd__s';
        a.appendChild(D.createElement('span')).textContent = str[i]; el.appendChild(a);
      }
      return;
    }
    for (i = 0; i < str.length; i++) {
      var sl = s[i];
      while (sl.children.length > 1) sl.removeChild(sl.firstElementChild);
      var cur = sl.lastElementChild;
      if (cur.textContent === str[i]) continue;
      if (instant || RM || !cur.animate) { cur.textContent = str[i]; continue; }
      var nw = D.createElement('span'); nw.textContent = str[i]; sl.appendChild(nw);
      cur.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-70%)', opacity: 0 }],
        { duration: 300, easing: EASE, fill: 'forwards' }).onfinish = (function (o) { return function () { if (o.parentNode) o.parentNode.removeChild(o); }; })(cur);
      nw.animate([{ transform: 'translateY(70%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 300, easing: EASE });
    }
  }
  function finish(c) {
    var host = c.el.closest('[data-bf-cd-host]') || c.el;
    var done = host.querySelector('[data-bf-cd-done]');
    if (c.el.getAttribute('data-ended') === 'text' && done) { c.el.hidden = true; done.hidden = false; }
    else host.hidden = true;
  }
  function tick() {
    var now = Date.now();
    cds.forEach(function (c) {
      if (c.done) return;
      var s = Math.max(0, Math.floor((c.end - now) / 1000));
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      if (c.inline) {
        var t = v.d + 'd ' + pad(v.h) + 'h ' + pad(v.m) + 'm ' + pad(v.s) + 's';
        if (c.el.textContent !== t) c.el.textContent = t;
      } else {
        c.units.forEach(function (u) { roll(u, pad(v[u.getAttribute('data-u')]), c.first); });
      }
      c.first = false;
      if (s === 0) { c.done = true; finish(c); }
    });
  }
  function countdowns(r) {
    each(r, '[data-bf-cd]', function (el) {
      if (el._bf) return; el._bf = 1;
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) { (el.closest('[data-bf-cd-host]') || el).hidden = true; return; }
      cds.push({ el: el, end: end, inline: el.hasAttribute('data-inline'), first: true,
        units: Array.prototype.slice.call(el.querySelectorAll('[data-u]')) });
    });
    if (cds.length) {
      tick();
      if (!timer) timer = setTimeout(function () { tick(); timer = setInterval(tick, 1000); }, 1000 - Date.now() % 1000);
    }
  }

  /* Pick your move: sliding pill, panel swap (View Transitions where supported), remembered for the session */
  function moves(r) {
    each(r, '[data-bf-move]', function (m) {
      if (m._bf) return; m._bf = 1;
      var tabs = Array.prototype.slice.call(m.querySelectorAll('[data-bf-tab]'));
      var phs = m.querySelectorAll('[data-bf-ph]'), ovs = m.querySelectorAll('[data-bf-over]'), rails = m.querySelectorAll('[data-bf-rail]');
      var pill = m.querySelector('[data-bf-pill]'), panel = m.querySelector('[data-bf-panel]');
      var key = 'bf-move-' + m.getAttribute('data-bf-move'), cur = -1;
      function place() {
        var b = tabs[cur]; if (!b || !pill || !b.offsetWidth) return;
        pill.style.width = b.offsetWidth + 'px'; pill.style.height = b.offsetHeight + 'px';
        pill.style.transform = 'translate(' + b.offsetLeft + 'px,' + b.offsetTop + 'px)';
      }
      function apply(i) {
        cur = i;
        tabs.forEach(function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        Array.prototype.forEach.call(phs, function (p, k) { p.classList.toggle('is-on', k === i); });
        Array.prototype.forEach.call(ovs, function (o, k) {
          o.hidden = k !== i; o.classList.remove('is-in');
          if (k === i && !RM) { void o.offsetWidth; o.classList.add('is-in'); }
        });
        Array.prototype.forEach.call(rails, function (x) { x.hidden = +x.getAttribute('data-bf-rail') !== i; });
        place();
      }
      function go(i) {
        if (i === cur) return;
        ss(key, String(i));
        if (!RM && D.startViewTransition && panel && panel.offsetWidth) {
          panel.classList.add('is-vt'); H.classList.add('bf-vt');
          var t = D.startViewTransition(function () { apply(i); });
          t.finished.then(clean, clean);
        } else apply(i);
      }
      function clean() { panel.classList.remove('is-vt'); H.classList.remove('bf-vt'); }
      tabs.forEach(function (b, k) {
        b.addEventListener('click', function (e) { e.preventDefault(); go(k); });
        b.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); go(k); } });
      });
      var saved = parseInt(ss(key), 10);
      var first = saved >= 0 && saved < Math.max(tabs.length, rails.length) ? saved : 0;
      apply(first);
      requestAnimationFrame(function () { m.classList.add('is-ready'); });
      W.addEventListener('resize', place, { passive: true });
    });
  }

  /* Desktop foil light that follows the pointer across BLACK FRIDAY */
  function glow(r) {
    if (!FINE || RM) return;
    each(r, '[data-bf-glow]', function (h) {
      if (h._bf) return; h._bf = 1;
      var sp = h.querySelectorAll('span'), raf = 0, x = 0, y = 0;
      h.classList.add('is-glow');
      h.addEventListener('pointermove', function (e) {
        x = e.clientX; y = e.clientY; if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          Array.prototype.forEach.call(sp, function (s) {
            var b = s.getBoundingClientRect();
            s.style.setProperty('--mx', (x - b.left) + 'px'); s.style.setProperty('--my', (y - b.top) + 'px');
          });
        });
      });
      h.addEventListener('pointerleave', function () {
        Array.prototype.forEach.call(sp, function (s) { s.style.setProperty('--mx', '-999px'); });
      });
    });
  }

  /* Toast: once per session after N seconds; Esc / × / swipe-down close it; never over the cart */
  function toast(r) {
    var t = r.querySelector('[data-bf-toast]');
    if (!t || t._bf) return; t._bf = 1;
    if (BLOCKED || ss('bf-toast')) return;
    var delay = (parseFloat(t.getAttribute('data-delay')) || 6) * 1000, shown = false;
    function ok() { return !drawerOpen() && !klaviyoOpen() && !modalOpen() && !D.hidden; }
    function show() {
      if (ss('bf-toast')) return;
      if (!ok()) { setTimeout(show, 2000); return; }
      ss('bf-toast', '1'); t.hidden = false; void t.offsetWidth;
      t.classList.add('is-in'); H.classList.add('bf-toast-on'); shown = true;
      var iv = setInterval(function () { if (!shown) return clearInterval(iv); if (drawerOpen() || klaviyoOpen() || modalOpen()) hide(); }, 700);
    }
    function hide() {
      if (!shown) return; shown = false;
      t.classList.remove('is-in'); H.classList.remove('bf-toast-on');
      setTimeout(function () { t.hidden = true; t.style.transform = ''; }, 230);
    }
    t._hide = hide;
    setTimeout(show, delay);
    var x = t.querySelector('[data-bf-x]'); if (x) x.addEventListener('click', hide);
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && shown) hide(); });
    var y0 = 0, t0 = 0, dy = 0, drag = false;
    t.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || e.target.closest('a,button')) return;
      drag = true; y0 = e.clientY; t0 = Date.now(); dy = 0; t.style.transition = 'none';
      try { t.setPointerCapture(e.pointerId); } catch (er) {}
    });
    t.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var d = e.clientY - y0; dy = d > 0 ? d : d / 4;
      t.style.transform = 'translateY(' + dy + 'px)';
    });
    function up() {
      if (!drag) return; drag = false; t.style.transition = '';
      var v = dy / Math.max(1, Date.now() - t0);
      if (dy > 56 || v > 0.11) { t.style.transform = ''; hide(); } else t.style.transform = '';
    }
    t.addEventListener('pointerup', up); t.addEventListener('pointercancel', up);
  }

  /* Early-access modal: exit intent on desktop, a quick scroll back up on phones; once per session */
  function modal(r) {
    var m = r.querySelector('[data-bf-modal]');
    if (!m || m._bf || typeof m.showModal !== 'function') return; m._bf = 1;
    function open() {
      if (m.open) return;
      var t = D.querySelector('[data-bf-toast]'); if (t && t._hide) t._hide();
      each(m, 'img[loading="lazy"]', function (i) { i.loading = 'eager'; });
      ss('bf-modal', '1'); m.showModal();
      requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.add('is-in'); }); });
    }
    m._open = open;
    function close() { m.classList.remove('is-in'); setTimeout(function () { if (m.open) m.close(); }, RM ? 0 : 240); }
    each(m, '[data-bf-close]', function (b) { b.addEventListener('click', close); });
    m.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    if (m.querySelector('[data-bf-posted]')) { open(); return; }
    if (BLOCKED || ss('bf-modal')) return;
    var armed = false;
    setTimeout(function () { armed = true; }, (parseFloat(m.getAttribute('data-arm')) || 5) * 1000);
    function ok() { return armed && !m.open && !ss('bf-modal') && !drawerOpen() && !klaviyoOpen(); }
    if (FINE) {
      D.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && ok()) open(); });
    } else {
      var ly = W.scrollY, lt = Date.now(), deep = 0;
      W.addEventListener('scroll', function () {
        var y = W.scrollY, n = Date.now();
        if (y > deep) deep = y;
        if ((ly - y) / Math.max(1, n - lt) > 1.4 && deep > W.innerHeight * 1.5 && ok()) open();
        ly = y; lt = n;
      }, { passive: true });
    }
  }

  /* Sticky things that appear once the hero has scrolled away and hide near the footer */
  function afterHero(el) {
    if (!hasIO) return;
    var hero = D.querySelector('.bf-hero'), foot = D.querySelector('.footer') || D.querySelector('footer');
    var past = !hero, near = false;
    function upd() { el.classList.toggle('is-in', past && !near); }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === hero) past = !e.isIntersecting && e.boundingClientRect.top < 0;
        else near = e.isIntersecting;
      });
      upd();
    });
    if (hero) io.observe(hero);
    if (foot) io.observe(foot);
    upd();
  }
  function stickies(r) {
    each(r, '[data-bf-sbar],[data-bf-scta]', function (el) { if (el._bf) return; el._bf = 1; afterHero(el); });
  }

  /* The deal: equation cards settle together on first view (content is visible without JS) */
  function reveal(r) {
    if (RM || !hasIO) return;
    each(r, '[data-bf-reveal]', function (el) {
      if (el._bf) return; el._bf = 1;
      if (el.getBoundingClientRect().top < W.innerHeight) return;
      el.classList.add('is-pre');
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { el.classList.remove('is-pre'); io.disconnect(); }
      }, { rootMargin: '0px 0px -15% 0px' });
      io.observe(el);
    });
  }

  /* VIP timeline: light the live step from the visitor's clock (server pages are cached, so this is client-side) */
  function vip(r) {
    each(r, '[data-bf-vip]', function (v) {
      if (v._bf) return; v._bf = 1;
      var steps = v.querySelectorAll('.bf-vip__step'), now = Date.now(), done = 0, fill = 0;
      Array.prototype.forEach.call(steps, function (st, i) {
        var a = Date.parse(st.getAttribute('data-start')), b = Date.parse(st.getAttribute('data-end'));
        if (isNaN(a) || isNaN(b)) return;
        if (now >= b) { st.classList.add('is-done'); done = i + 1; }
        else if (now >= a) {
          st.classList.add('is-now'); var n = st.querySelector('.bf-vip__now'); if (n) n.hidden = false;
          fill = (i + (now - a) / (b - a)) / steps.length;
        }
      });
      if (!fill) fill = done / steps.length;
      v.style.setProperty('--bf-vip', Math.round(fill * 100) + '%');
      var cta = v.querySelector('[data-bf-open-modal]'), m = D.querySelector('[data-bf-modal]');
      if (cta && m && typeof m._open === 'function') {
        cta.hidden = false;
        cta.addEventListener('click', function () { m._open(); });
      }
    });
  }

  /* VIP week: while html.bf-locked, shop links open the VIP sign-up (or jump to the deal); unlock live at the set time */
  function locks() {
    if (!H.classList.contains('bf-locked') || H._bfLock) return; H._bfLock = 1;
    D.addEventListener('click', function (e) {
      if (!H.classList.contains('bf-locked')) return;
      var a = e.target.closest('[data-bf-lockable], .bf-grid--lockable > li');
      if (!a) return;
      e.preventDefault(); e.stopPropagation();
      var m = D.querySelector('[data-bf-modal]');
      if (m && typeof m._open === 'function') m._open();
      else { var d = D.getElementById('bf-deal'); if (d) d.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); }
    }, true);
    var t = +H.getAttribute('data-bf-unlock'), ms = t - Date.now();
    if (ms > 0 && ms < 864e5) setTimeout(function () { H.classList.remove('bf-locked'); }, ms);
  }

  function init(r) {
    safe(tickers, r); safe(countdowns, r); safe(moves, r); safe(glow, r);
    safe(toast, r); safe(modal, r); safe(stickies, r); safe(reveal, r); safe(vip, r); safe(locks, r);
  }
  init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
